import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
	lockedAlert: {
		fontSize: 16,
		fontWeight: 600,
		padding: 20,
		border: '2px solid #ff9800',
		marginTop: 20,
		marginBottom: 10,
		backgroundColor: '#fff3e0',
		color: '#e65100',
		borderRadius: 4,
	},
});

/**
 * Banner shown on a delivery whose invoice has been issued (the record is locked).
 */
function LockedDeliveryAlert({ classes, canEditLocked }) {
	return (
		<div className={classes.lockedAlert}>
			An invoice has been issued for this delivery, so it is LOCKED.
			{canEditLocked
				? ' You have permission to change it anyway — every change requires a reason and is recorded.'
				: ' Only the internal note can be changed.'}
		</div>
	);
}

LockedDeliveryAlert.propTypes = {
	classes: PropTypes.object.isRequired,
	canEditLocked: PropTypes.bool,
};

export default withStyles(styles)(LockedDeliveryAlert);
